import validate from "/Users/tom/hacking/energysage/es-poc-auth0-fe/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/tom/hacking/energysage/es-poc-auth0-fe/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/Users/tom/hacking/energysage/es-poc-auth0-fe/nuxt-app/middleware/authenticated.ts"),
  auth: () => import("/Users/tom/hacking/energysage/es-poc-auth0-fe/nuxt-app/modules/nuxtAuth0/runtime/createAuthRouterGuard.ts")
}